import { getLogger } from "@utils/ermineLoggerUtils";
import { useMutation } from "@tanstack/react-query";
import { sendSignOutCommand } from "@utils/ermineSsrClientUtil";
import { getFormattedSdkErrorMessage } from "@utils/errorUtils";

export const useSignOut = () => {
    const result = useMutation({
        mutationFn: async () => {
            try {
                return await sendSignOutCommand();
            } catch (err) {
                await getLogger().error(
                    err
                        ? getFormattedSdkErrorMessage(err, "SSOSignOut")
                        : "Failed to sign out"
                );
                throw err;
            }
        },
    });

    return {
        signOut: result.mutateAsync,
        response: result.data,
        isSigningOut: result.isLoading,
        error: result.error,
    };
};
